import { initErrorEventCatcher } from './catcher';
import { initSentry } from './sentry';

export const InitGlobalErrorProcessor = () => {
	initErrorEventCatcher();
	initSentry();
};
